/**
 *
 * @param src
 * @returns strng updated path to image
 */
export const imageLoader = ({
  src,
  width,
  quality,
}: {
  src: string
  width?: string | number
  quality?: string | number
}) => {
  // console.log("Image SRC:", src);
  const domain = process.env.NEXT_PUBLIC_BASE_URL || ''
  if (
    src.startsWith(domain) ||
    src.startsWith('http://') ||
    src.startsWith('https://')
  ) {
    if (src.startsWith(domain + domain)) {
      return src.slice(domain.length)
    }
    return `${src}?w=${width}&q=${quality || 75}`
  } else {
    return `${domain}${src}?w=${width}&q=${quality || 75}`
  }
}
